import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TRACKING } from '../../enums/trackingParts.enum';
import { TariffAdvisorService } from '../../services/tariff-advisor.service';
import { ReBaseData } from '../../../shared/utils/re-base-data';

@Component({
    selector: 'bdo-effzeh-strom-teaser',
    templateUrl: './effzeh-strom-teaser.component.html',
    styleUrl: './effzeh-strom-teaser.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EffzehStromTeaserComponent implements OnInit {
  @Input() productIds: Array<string>;
  public TRACKING = TRACKING;
  public isEffzeh = false;
  protected reBaseData = ReBaseData;

  constructor(
    private tariffService: TariffAdvisorService
  ) { }

  ngOnInit(): void {
    this.isEffzeh = this.tariffService.isEffzeh(this.productIds);
  }

}
